/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export class SubmitIndividualCorporationStatusRequestModel { 
    /**
     * ADRE WorkflowID returned in StarFunction service
     */
    WorkflowID: number;
    /**
     * The current step in the workflow from the UI perspective used for validation purposes
     */
    CurrentStepIndex: number;
    /**
     * Continue with corporation status
     */
    ContinueWithCorporationStatus: boolean =false;
}



// WEBPACK FOOTER //
// ./src/app/model/submitIndividualCorporationStatusRequestModel.ts